import { Controller } from "@hotwired/stimulus"

// Listens to Turbo navigation and frame events to keep the chat panel
// aware of what the user is currently viewing. Updates a visual indicator
// and ensures the next message will carry the latest page context.
export default class extends Controller {
  static targets = ["indicator"]

  connect() {
    this.onNavigate = this.handlePageChange.bind(this)
    this.onFrameLoad = this.handlePageChange.bind(this)

    document.addEventListener("turbo:load", this.onNavigate)
    document.addEventListener("turbo:frame-load", this.onFrameLoad)

    // Set initial state
    this.updateIndicator()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onNavigate)
    document.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  handlePageChange() {
    this.updateIndicator()
  }

  updateIndicator() {
    if (!this.hasIndicatorTarget) return

    const label = this.getPageTitle()

    this.indicatorTarget.textContent = label

    // Flash animation to signal context changed
    this.indicatorTarget.classList.remove("animate-pulse")
    void this.indicatorTarget.offsetWidth
    this.indicatorTarget.classList.add("animate-pulse")
    setTimeout(() => this.indicatorTarget.classList.remove("animate-pulse"), 2000)
  }

  getPageTitle() {
    const el = document.getElementById("page-title-text")
    return el?.textContent?.trim() || ""
  }
}
